import React from "react";

export default function DrawerDetails() {
  return <div>Drawer Details</div>;
}
